<script lang="ts">
    import orderBy from 'lodash/orderBy';
    import sumBy from 'lodash/sumBy';
    import filter from 'lodash/filter';
    import { getReactionsData } from './Utils';
    import { cx } from '$lib/utils/cx.js';
    import { createEventDispatcher } from 'svelte';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    export let type: string | null;
    export let counters: { count: number; type: string }[];

    const { lang } = getContainer();
    const dispatch = createEventDispatcher<{
        select: string | null;
    }>();

    $: reactionsData = getReactionsData($lang);

    function getList() {
        let list = [
            {
                type: null,
                count: sumBy(counters, (counter) => counter.count),
            },
            ...counters,
        ];
        list = filter(list, (counter) => counter.count > 0);
        list = orderBy(list, (counter) => counter.count, 'desc');
        return list;
    }

    $: list = getList() as {
        count: number;
        type: keyof typeof reactionsData.images;
    }[];
</script>

<div class={'flex items-center gap-6'}>
    {#each list as counter (counter.type)}
        <button
            on:click|preventDefault={() => dispatch('select', counter.type)}
            class={cx(
                'btn-reset bg-transparent border-0 cursor-pointer flex items-center gap-2 p-4 hover:bg-gray-50',
                counter.type === type ? 'border-b-2 border-link' : '',
            )}
        >
            {#if counter.type != null}
                <img
                    src={reactionsData.images[counter.type]}
                    alt={reactionsData.labels[counter.type]}
                    class={'h-8 w-8'}
                />
            {:else}
                <span>
                    {t.reactions.list_modal_all({}, $lang)}
                </span>
            {/if}
            <span class={cx(counter.type === type ? 'text-link' : '')}
                >{counter.count}</span
            >
        </button>
    {/each}
</div>
